import React, { useContext }  from "react";
import "../../../ui-styles/calling/incomingCallModal.css";
import "../../../ui-styles/animations/callAnimation.css";

import { LangCtx } from "../../../lib/context";

const IncommingCall = (props) => {
    console.log("props::::", props);
    const { l } = useContext(LangCtx);
    let name = props && props.userData && props.userData.firstName ? props.userData.firstName : '';
    name += props && props.userData && props.userData.lastName ? " " + props.userData.lastName : '';
    return (
        <div className={props.inCall ? "callModalCntnr showModal": "callModalCntnr"}>
            <div className="callingCntnr">
                <div className="callingTB topHight">
                    <div className="callingHdr">
                        <span className="callHdrLTxt">{l.incmng_call}...</span>
                    </div>

                </div>

                <div className="callingBdy">
                    <div className="callAnimation">
                        <img src={props && props.userData && props.userData.profileImage && props.userData.profileImage.url ? props.userData.profileImage.url : "/images/pics/m1.jpg"} alt="profile pic" className="profilePic" />
                    </div>
                    <span className="nameTxt">{`Dr. ${name}`}</span>
                    <audio className={props.inCall ? "noVisible":"noDisplay"} autoPlay loop>
                        <source src="/audio/phone_ringing.mp3" type="audio/mpeg" />
                        <source src="/audio/phone_ringing.ogg" type="audio/ogg" />
                    </audio>
                </div>

                        <div className="callingTB btmHight">
                            <div className="callingFtr">
                                <div className="circleBtnItem">
                                    <button className="callBtnItem dangerColor" onClick={props.handleInCall}>
                                        <img src="/images/icons/phone.png" className="invertWhite" alt="icon" />
                                    </button>
                                    <span className="btnTxt">{l.decline}</span>
                                </div>
                                <div className="circleBtnItem">
                                    <button className="callBtnItem successColor" onClick={props.handleAccept}>
                                        <img src="/images/icons/call-phone.png" className="invertWhite" alt="icon" />
                                    </button>
                                    <span className="btnTxt">{l.answer}</span>
                                </div>
                            </div>
                        </div>
            </div>
                </div>
    )
}
export default IncommingCall;